import React from 'react';
import { Badge, Button } from '@mui/material';
import { getValueText } from './FilterPod';
import { Icons } from 'components';

const FilterButton = ({
  setOpenFilterDialog,
  filters
}) => {
  const filterCount = filters.reduce((acc, cur) => getValueText(cur) ? acc + 1 : acc, 0);
  return (
    <Badge
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      color="error"
      badgeContent={filterCount}
      variant="dot"
      style={{ marginLeft: "auto" }}
    >
      <Button
        onClick={() => setOpenFilterDialog(true)}
        color="primary"
        startIcon={<Icons icon="FIilter" color="#ffffff" size="20" />}
        variant="contained"
      >
        فیلتر
      </Button>
    </Badge>
  );
};

export default FilterButton;
